import { Calendar } from "primereact/calendar";

const DateRowFilterTemplate = (options) => {
    return (
        <Calendar
            value={options.value}
            onChange={
                (e) => options.filterApplyCallback(e.value)
            }
            dateFormat="dd.mm.yy"
            selectionMode="range"
            readOnlyInput
            hideOnRangeSelection
        />
    );
};

export default DateRowFilterTemplate;